// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent_pane {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--color-bg-2);
}

/* Session tabs */

.agent_pane__tabs {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 1px;
    border-bottom: 1px solid var(--color-border);
    background-color: var(--color-bg);
    padding: 0 4px;
    overflow-x: auto;
    scrollbar-width: none;
    min-height: 38px;
}

.agent_pane__tab {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 0 12px 0 14px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    color: var(--color-text-muted);
    white-space: nowrap;
    user-select: none;
    transition: color 0.1s;
}

@media (pointer: fine) {
    .agent_pane__tab:hover {
        color: var(--color-text);
    }
}

@media (pointer: coarse) {
    .agent_pane__tabs {
        min-height: 44px;
    }

    .agent_pane__tab {
        font-size: 13px;
        padding: 0 10px 0 12px;
    }
}

.agent_pane__tab--active {
    color: var(--color-text);
    border-bottom-color: var(--color-accent);
}

.agent_pane__tab_label {
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.agent_pane__tab_spinner {
    flex-shrink: 0;
    display: block;
    width: 8px;
    height: 8px;
    border: 1.5px solid var(--color-border);
    border-top-color: var(--color-accent);
    border-radius: 50%;
    animation: agent_pane_spin 0.7s linear infinite;
}

.agent_pane__tab_close {
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0 4px;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    color: var(--color-text-muted);
    opacity: 0.5;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .agent_pane__tab_close:hover {
        opacity: 1;
    }
}


.agent_pane__tab_new {
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0 10px;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    color: var(--color-text-muted);
    opacity: 0.5;
    transition: opacity 0.1s;
    align-self: center;
}

@media (pointer: fine) {
    .agent_pane__tab_new:hover:not(:disabled) {
        opacity: 1;
    }
}

.agent_pane__tab_new:disabled {
    cursor: default;
    opacity: 0.2;
}

/* Loading state */

.agent_pane__loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agent_pane__loading_spinner {
    display: block;
    width: 22px;
    height: 22px;
    border: 2px solid var(--color-border);
    border-top-color: var(--color-accent);
    border-radius: 50%;
    animation: agent_pane_spin 0.7s linear infinite;
}

@keyframes agent_pane_spin {
    to { transform: rotate(360deg); }
}

/* Empty state */

.agent_pane__empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.agent_pane__empty_btn {
    padding: 8px 22px;
    background-color: var(--color-accent);
    color: #ffffff;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    opacity: 0.9;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .agent_pane__empty_btn:hover:not(:disabled) {
        opacity: 1;
    }
}

.agent_pane__empty_btn:disabled {
    opacity: 0.4;
    cursor: default;
}


/* Last user prompt banner (shown when last user message is scrolled above viewport) */

.agent_pane__prompt_banner {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 7px 13px;
    background-color: var(--color-bg);
    font-size: 13px;
    font-weight: 500;
    color: var(--color-text);
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;
    transition: background-color 0.1s;
}

.agent_pane__prompt_banner--top {
    top: 0;
    border-bottom: 1px solid var(--color-border);
}

.agent_pane__prompt_banner--bottom {
    bottom: 0;
    border-top: 1px solid var(--color-border);
}

@media (pointer: fine) {
    .agent_pane__prompt_banner:hover {
        background-color: var(--color-bg-2);
        filter: brightness(1.05);
    }
}

/* Timeline */

.agent_pane__timeline_wrap {
    flex: 1;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
}

.agent_pane__scroll_btn {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    padding: 3px 12px;
    background-color: var(--color-bg);
    border: 1px solid var(--color-border);
    border-radius: 12px;
    font-size: 13px;
    color: var(--color-text-muted);
    cursor: pointer;
    opacity: 0.85;
    transition: opacity 0.1s;
    z-index: 1;
    white-space: nowrap;
    user-select: none;
}

@media (pointer: fine) {
    .agent_pane__scroll_btn:hover {
        opacity: 1;
    }
}

.agent_pane__timeline_wrap[data-banner-bottom] .agent_pane__scroll_btn {
    bottom: calc(12px + 35px);
}

.agent_pane__timeline {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 9px;
    scrollbar-width: thin;
}

.agent_pane__item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding-top: 5px;
    padding-left: 13px;
    padding-right: 13px;
}

.agent_pane__item_label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    user-select: none;
}

.agent_pane__item_content {
    font-size: 13px;
    line-height: 1.5;
}

.agent_pane__item_pre {
    margin: 0;
    padding: 0;
    font: inherit;
    white-space: pre-wrap;
    word-break: break-word;
    overflow: hidden;
}

/* Thought */

.agent_pane__item--thought .agent_pane__item_label {
    color: var(--color-text-muted);
}

.agent_pane__item--thought .agent_pane__item_content {
    color: var(--color-text-muted);
    font-style: italic;
}

/* Action */

.agent_pane__item--action .agent_pane__item_label {
    color: var(--color-accent);
}

.agent_pane__item--action .agent_pane__item_content {
    color: var(--color-text);
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    background-color: var(--color-bg);
    border-radius: 3px;
    padding: 6px 9px;
}

/* Result */

.agent_pane__item--result .agent_pane__item_label {
    color: var(--color-text-muted);
}

.agent_pane__item--result .agent_pane__item_content {
    color: var(--color-text);
}

/* User */

.agent_pane__item--user .agent_pane__item_label {
    color: var(--color-accent);
}

.agent_pane__item--user .agent_pane__item_content {
    color: var(--color-text);
    font-weight: 500;
}

/* Pending */

.agent_pane__item--pending {
    opacity: 0.5;
}

/* Assistant */

.agent_pane__item--assistant .agent_pane__item_label {
    color: var(--color-text-muted);
}

.agent_pane__item--assistant .agent_pane__item_content {
    color: var(--color-text);
}

/* Markdown rendering */

.agent_pane__item_content--markdown {
    line-height: 1.6;
}

.agent_pane__item_content--markdown > :first-child {
    margin-top: 0;
}

.agent_pane__item_content--markdown > :last-child {
    margin-bottom: 0;
}

.agent_pane__item_content--markdown p {
    margin: 0 0 0.6em;
}

.agent_pane__item_content--markdown h1,
.agent_pane__item_content--markdown h2,
.agent_pane__item_content--markdown h3,
.agent_pane__item_content--markdown h4,
.agent_pane__item_content--markdown h5,
.agent_pane__item_content--markdown h6 {
    margin: 0.8em 0 0.3em;
    font-weight: 600;
    line-height: 1.3;
}

.agent_pane__item_content--markdown h1 { font-size: 1.2em; }
.agent_pane__item_content--markdown h2 { font-size: 1.1em; }
.agent_pane__item_content--markdown h3,
.agent_pane__item_content--markdown h4,
.agent_pane__item_content--markdown h5,
.agent_pane__item_content--markdown h6 { font-size: 1em; }

.agent_pane__item_content--markdown ul,
.agent_pane__item_content--markdown ol {
    margin: 0 0 0.6em;
    padding-left: 1.4em;
}

.agent_pane__item_content--markdown li {
    margin-bottom: 0.2em;
}

.agent_pane__item_content--markdown li > p {
    margin-bottom: 0.2em;
}

.agent_pane__item_content--markdown code {
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 0.9em;
    background-color: var(--color-bg);
    padding: 1px 5px;
    border-radius: 3px;
}

.agent_pane__item_content--markdown pre {
    margin: 0.5em 0;
    padding: 8px 11px;
    background-color: var(--color-bg);
    border-radius: 4px;
    overflow-x: auto;
}

.agent_pane__item_content--markdown pre code {
    background: none;
    padding: 0;
    font-size: 12px;
    white-space: pre;
}

.agent_pane__item_content--markdown blockquote {
    margin: 0.5em 0;
    padding: 0 0 0 10px;
    border-left: 3px solid var(--color-border);
    color: var(--color-text-muted);
}

.agent_pane__item_content--markdown hr {
    border: none;
    border-top: 1px solid var(--color-border);
    margin: 0.6em 0;
}

.agent_pane__item_content--markdown a {
    color: var(--color-accent);
    text-decoration: none;
}

.agent_pane__item_content--markdown a:hover {
    text-decoration: underline;
}

.agent_pane__item_content--markdown strong {
    font-weight: 600;
}

.agent_pane__item_content--markdown table {
    border-collapse: collapse;
    margin: 0.5em 0;
    font-size: 12px;
    width: 100%;
}

.agent_pane__item_content--markdown th,
.agent_pane__item_content--markdown td {
    border: 1px solid var(--color-border);
    padding: 4px 8px;
    text-align: left;
}

.agent_pane__item_content--markdown th {
    background-color: var(--color-bg);
    font-weight: 600;
}

/* Tool use widgets */

.agent_pane__tool_widget {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 7px;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    background-color: var(--color-bg);
    border-radius: 3px;
    padding: 5px 9px;
    overflow: hidden;
}

.agent_pane__tool_widget--clickable {
    cursor: pointer;
    transition: background-color 0.1s;
}

@media (pointer: fine) {
    .agent_pane__tool_widget--clickable:hover {
        background-color: color-mix(in srgb, var(--color-accent) 8%, var(--color-bg));
    }
}

.agent_pane__tool_widget_label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    flex-shrink: 0;
    opacity: 0.65;
}

.agent_pane__tool_widget--read .agent_pane__tool_widget_label  { color: var(--color-accent); }
.agent_pane__tool_widget--edit .agent_pane__tool_widget_label  { color: var(--color-warning, #e5a000); }
.agent_pane__tool_widget--write .agent_pane__tool_widget_label { color: var(--color-warning, #e5a000); }
.agent_pane__tool_widget--bash .agent_pane__tool_widget_label  { color: var(--color-success, #3fa542); }
.agent_pane__tool_widget--grep .agent_pane__tool_widget_label  { color: var(--color-accent); }
.agent_pane__tool_widget--glob .agent_pane__tool_widget_label  { color: var(--color-accent); }

.agent_pane__tool_widget_path {
    color: var(--color-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
}

.agent_pane__tool_widget_range,
.agent_pane__tool_widget_meta {
    flex-shrink: 0;
    color: var(--color-text-muted);
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Bash widget */

.agent_pane__tool_widget--bash {
    flex-direction: column;
    align-items: stretch;
    gap: 3px;
}

.agent_pane__tool_widget_desc {
    font-family: inherit;
    font-size: 11px;
    color: var(--color-text-muted);
    font-style: italic;
}

.agent_pane__tool_widget_cmd {
    margin: 0;
    padding: 0;
    font: inherit;
    white-space: pre-wrap;
    word-break: break-word;
    color: var(--color-text);
}

.agent_pane__tool_widget_prompt {
    color: var(--color-accent);
    font-weight: 700;
    user-select: none;
}

/* Permission */

.agent_pane__item--permission .agent_pane__item_label {
    color: var(--color-warning, #e5a000);
}

.agent_pane__perm_tool {
    font-size: 13px;
    font-weight: 600;
    color: var(--color-text);
    margin-bottom: 4px;
}

.agent_pane__perm_input {
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 12px;
    background-color: var(--color-bg);
    border-radius: 3px;
    padding: 6px 9px;
    margin: 4px 0;
    white-space: pre-wrap;
    word-break: break-all;
    max-height: 132px;
    overflow-y: auto;
}

.agent_pane__perm_actions {
    display: flex;
    gap: 7px;
    margin-top: 7px;
}

.agent_pane__perm_btn {
    padding: 3px 13px;
    border: none;
    border-radius: 3px;
    font-size: 12px;
    cursor: pointer;
    transition: opacity 0.1s;
}

.agent_pane__perm_btn--approve {
    background-color: var(--color-accent);
    color: #ffffff;
}

.agent_pane__perm_btn--approve_always {
    background-color: var(--color-accent);
    color: #ffffff;
    opacity: 0.75;
}

.agent_pane__perm_btn--deny {
    background-color: var(--color-bg);
    color: var(--color-text);
    border: 1px solid var(--color-border);
}

@media (pointer: fine) {
    .agent_pane__perm_btn:hover {
        opacity: 0.8;
    }
}

.agent_pane__perm_responded {
    font-size: 12px;
    color: var(--color-text-muted);
    margin-top: 4px;
    font-style: italic;
}

/* Log (debug) */

.agent_pane__item--log .agent_pane__item_label {
    color: var(--color-text-muted);
    opacity: 0.6;
}

.agent_pane__log {
    display: flex;
    gap: 9px;
    align-items: baseline;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
    color: var(--color-text-muted);
    opacity: 0.7;
}

.agent_pane__log_source {
    font-weight: 600;
    flex-shrink: 0;
}

.agent_pane__log_path {
    word-break: break-all;
}

/* Collapsible tool usage blocks (action / result) */

.agent_pane__item_content--collapsible {
    cursor: pointer;
}

.agent_pane__item_content--collapsed {
    position: relative;
}

.agent_pane__item_content--collapsed .agent_pane__item_pre {
    max-height: 4.5em;
    overflow: hidden;
    mask-image: linear-gradient(to bottom, black 30%, transparent 100%);
    -webkit-mask-image: linear-gradient(to bottom, black 30%, transparent 100%);
}

.agent_pane__item--action .agent_pane__item_pre,
.agent_pane__item--result .agent_pane__item_pre {
    min-height: 4.5em;
}

.agent_pane__expand_hint {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 11px;
    letter-spacing: 0.25em;
    color: var(--color-text-muted);
    opacity: 0.55;
    user-select: none;
}

/* Interrupted indicator */

.agent_pane__interrupted {
    margin-top: 7px;
    font-size: 12px;
    color: var(--color-warning, #e5a000);
    font-style: italic;
}

/* Thinking / working indicator */

.agent_pane__thinking {
    font-size: 12px;
    color: var(--color-text-muted);
    opacity: 0.6;
    font-style: italic;
    padding: 2px 0 4px;
    user-select: none;
}

/* Streaming indicator — three pulsing dots */

.agent_pane__streaming_indicator {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 0;
}

.agent_pane__streaming_indicator span {
    display: block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: var(--color-text-muted);
    animation: agent_pane_dot_pulse 1.2s ease-in-out infinite;
}

.agent_pane__streaming_indicator span:nth-child(2) { animation-delay: 0.2s; }
.agent_pane__streaming_indicator span:nth-child(3) { animation-delay: 0.4s; }

@keyframes agent_pane_dot_pulse {
    0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
    40%            { opacity: 1;   transform: scale(1); }
}

/* Input area */

.agent_pane__input_area {
    flex-shrink: 0;
    padding: 11px 13px;
    border-top: 1px solid var(--color-border);
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.agent_pane__input_row {
    display: flex;
    flex-direction: row;
    gap: 9px;
    align-items: flex-end;
}

/* Context bar */

.agent_pane__context_chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding-bottom: 4px;
}

.agent_pane__context_bar {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 3px 8px;
    background-color: color-mix(in srgb, var(--color-accent) 12%, transparent);
    border: 1px solid color-mix(in srgb, var(--color-accent) 35%, transparent);
    border-radius: 4px;
    font-size: 12px;
    color: var(--color-accent);
    user-select: none;
    min-width: 0;
}

.agent_pane__context_icon {
    flex-shrink: 0;
    font-weight: 700;
}

.agent_pane__context_name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "JetBrains Mono", "Fira Code", Menlo, monospace;
    font-size: 11px;
}

.agent_pane__context_dismiss {
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 0 2px;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
    color: var(--color-accent);
    opacity: 0.6;
    transition: opacity 0.1s;
}

@media (pointer: fine) {
    .agent_pane__context_dismiss:hover {
        opacity: 1;
    }
}

/* Context toggle button */

.agent_pane__context_btn {
    flex-shrink: 0;
    padding: 6px 9px;
    height: 31px;
    box-sizing: border-box;
    background: none;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    color: var(--color-text-muted);
    transition: color 0.1s, border-color 0.1s, background-color 0.1s;
}

@media (pointer: fine) {
    .agent_pane__context_btn:hover {
        color: var(--color-text);
        border-color: var(--color-text-muted);
    }
}

.agent_pane__context_btn--active {
    color: var(--color-accent);
    border-color: var(--color-accent);
    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);
}

/* Backend chooser (shown before first prompt) */

.agent_pane__backend_chooser {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.agent_pane__backend_label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    user-select: none;
    flex-shrink: 0;
    margin-right: 2px;
}

.agent_pane__backend_btn {
    padding: 2px 9px;
    background: none;
    border: 1px solid var(--color-border);
    border-radius: 3px;
    font-size: 11px;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: color 0.1s, border-color 0.1s, background-color 0.1s;
    user-select: none;
}

@media (pointer: fine) {
    .agent_pane__backend_btn:hover {
        color: var(--color-text);
        border-color: var(--color-text-muted);
    }
}

.agent_pane__backend_btn--active {
    color: var(--color-accent);
    border-color: var(--color-accent);
    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);
}

.agent_pane__input_area .text_input--textarea {
    min-height: unset;
    height: 31px;
    padding-top: 6px;
    padding-bottom: 6px;
    overflow: hidden;
    line-height: normal;
}

@media (pointer: fine) and (pointer: fine) {
    .agent_pane__input_area .text_input--textarea {
        transition: height 0.15s ease;
    }

    .agent_pane__input_area .text_input--textarea:focus,
    .agent_pane__input_area .text_input--textarea:not(:placeholder-shown) {
        height: 90px;
        overflow: auto;
    }
}

.agent_pane__settings_btn {
    flex-shrink: 0;
    padding: 6px 10px;
    height: 31px;
    box-sizing: border-box;
    background: none;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    font-size: 15px;
    line-height: 1;
    cursor: pointer;
    color: var(--color-text-muted);
    transition: color 0.1s, border-color 0.1s;
}

@media (pointer: fine) {
    .agent_pane__settings_btn:hover {
        color: var(--color-text);
        border-color: var(--color-text-muted);
    }
}

.agent_pane__send_btn {
    flex-shrink: 0;
    padding: 6px 18px;
    height: 31px;
    box-sizing: border-box;
    background-color: var(--color-accent);
    color: #ffffff;
    border: none;
    border-radius: 4px;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.1s, opacity 0.1s;
}

@media (pointer: fine) {
    .agent_pane__send_btn:hover:not(:disabled) {
        background-color: var(--color-accent-hover);
    }
}

.agent_pane__send_btn:disabled {
    opacity: 0.4;
    cursor: default;
}

.agent_pane__send_btn--stop {
    background-color: var(--color-danger, #d94f4f);
}

@media (pointer: fine) {
    .agent_pane__send_btn--stop:hover {
        background-color: var(--color-danger-hover, #c04040);
    }
}

/* Per-session settings modal */

.agent_pane__session_settings {
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 240px;
    /* Room for long ids like openrouter/deepseek/deepseek-v4-pro in the model picker. */
    width: min(420px, 80vw);
}

.agent_pane__session_settings_section {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.agent_pane__session_settings_label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--color-text-muted);
    user-select: none;
}

.agent_pane__session_settings_options {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.agent_pane__session_settings_btn {
    padding: 3px 10px;
    background: none;
    border: 1px solid var(--color-border);
    border-radius: 3px;
    font-size: 12px;
    color: var(--color-text-muted);
    cursor: pointer;
    transition: color 0.1s, border-color 0.1s, background-color 0.1s;
    user-select: none;
}

@media (pointer: fine) {
    .agent_pane__session_settings_btn:hover {
        color: var(--color-text);
        border-color: var(--color-text-muted);
    }
}

/* SelectInput defaults to flex: 1, which would stretch it vertically in this column. */
.agent_pane__session_settings_select {
    flex: none;
    width: 100%;
}

.agent_pane__session_settings_status {
    font-size: 12px;
    color: var(--color-text-muted);
}

.agent_pane__session_settings_status--error {
    color: var(--color-error);
    white-space: pre-wrap;
}

.agent_pane__session_settings_btn--active {
    color: var(--color-accent);
    border-color: var(--color-accent);
    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);
}

`, "",{"version":3,"sources":["webpack://./components/AgentPane/s.agent_pane.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA,iBAAiB;;AAEjB;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,4CAA4C;IAC5C,iCAAiC;IACjC,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,oCAAoC;IACpC,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;AACJ;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,uCAAuC;IACvC,qCAAqC;IACrC,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA,kBAAkB;;AAElB;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;;AAEhB;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;;AAGA,sFAAsF;;AAEtF;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,MAAM;IACN,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI;QACI,mCAAmC;QACnC,wBAAwB;IAC5B;AACJ;;AAEA,aAAa;;AAEb;IACI,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,iCAAiC;IACjC,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,aAAa;IACb,wBAAwB;IACxB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA,WAAW;;AAEX;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,4DAA4D;IAC5D,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,WAAW;;AAEX;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,SAAS;;AAET;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ;IACI,YAAY;AAChB;;AAEA,cAAc;;AAEd;IACI,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,uBAAuB;;AAEvB;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;IAMI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,yCAAyC,gBAAgB,EAAE;AAC3D,yCAAyC,gBAAgB,EAAE;AAC3D;;;yCAGyC,cAAc,EAAE;;AAEzD;;IAEI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,4DAA4D;IAC5D,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI;QACI,6EAA6E;IACjF;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA,iEAAiE,0BAA0B,EAAE;AAC7F,iEAAiE,oCAAoC,EAAE;AACvG,iEAAiE,oCAAoC,EAAE;AACvG,iEAAiE,oCAAoC,EAAE;AACvG,iEAAiE,0BAA0B,EAAE;AAC7F,iEAAiE,0BAA0B,EAAE;;AAE7F;IACI,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,gBAAgB;;AAEhB;IACI,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,eAAe;;AAEf;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,4DAA4D;IAC5D,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA,gBAAgB;;AAEhB;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,4DAA4D;IAC5D,eAAe;IACf,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oDAAoD;;AAEpD;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mEAAmE;IACnE,2EAA2E;AAC/E;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,iBAAiB;AACrB;;AAEA,0BAA0B;;AAE1B;IACI,eAAe;IACf,eAAe;IACf,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA,iCAAiC;;AAEjC;IACI,eAAe;IACf,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,6CAA6C;;AAE7C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,yDAAyD;AAC7D;;AAEA,qDAAqD,qBAAqB,EAAE;AAC5E,qDAAqD,qBAAqB,EAAE;;AAE5E;IACI,gBAAgB,YAAY,EAAE,qBAAqB,EAAE;IACrD,iBAAiB,UAAU,IAAI,mBAAmB,EAAE;AACxD;;AAEA,eAAe;;AAEf;IACI,cAAc;IACd,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;AACzB;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,0EAA0E;IAC1E,0EAA0E;IAC1E,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,4DAA4D;IAC5D,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA,0BAA0B;;AAE1B;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,gEAAgE;AACpE;;AAEA;IACI;QACI,wBAAwB;QACxB,qCAAqC;IACzC;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,0EAA0E;AAC9E;;AAEA,gDAAgD;;AAEhD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,gEAAgE;IAChE,iBAAiB;AACrB;;AAEA;IACI;QACI,wBAAwB;QACxB,qCAAqC;IACzC;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,0EAA0E;AAC9E;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,6BAA6B;IACjC;;IAEA;;QAEI,YAAY;QACZ,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI;QACI,wBAAwB;QACxB,qCAAqC;IACzC;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,qCAAqC;IACrC,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;QACI,oDAAoD;IACxD;AACJ;;AAEA,+BAA+B;;AAE/B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,oFAAoF;IACpF,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,gEAAgE;IAChE,iBAAiB;AACrB;;AAEA;IACI;QACI,wBAAwB;QACxB,qCAAqC;IACzC;AACJ;;AAEA,uFAAuF;AACvF;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,0EAA0E;AAC9E","sourcesContent":[".agent_pane {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--color-bg-2);\n}\n\n/* Session tabs */\n\n.agent_pane__tabs {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 1px;\n    border-bottom: 1px solid var(--color-border);\n    background-color: var(--color-bg);\n    padding: 0 4px;\n    overflow-x: auto;\n    scrollbar-width: none;\n    min-height: 38px;\n}\n\n.agent_pane__tab {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 0 12px 0 14px;\n    font-size: 13px;\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    color: var(--color-text-muted);\n    white-space: nowrap;\n    user-select: none;\n    transition: color 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__tab:hover {\n        color: var(--color-text);\n    }\n}\n\n@media (pointer: coarse) {\n    .agent_pane__tabs {\n        min-height: 44px;\n    }\n\n    .agent_pane__tab {\n        font-size: 13px;\n        padding: 0 10px 0 12px;\n    }\n}\n\n.agent_pane__tab--active {\n    color: var(--color-text);\n    border-bottom-color: var(--color-accent);\n}\n\n.agent_pane__tab_label {\n    max-width: 110px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.agent_pane__tab_spinner {\n    flex-shrink: 0;\n    display: block;\n    width: 8px;\n    height: 8px;\n    border: 1.5px solid var(--color-border);\n    border-top-color: var(--color-accent);\n    border-radius: 50%;\n    animation: agent_pane_spin 0.7s linear infinite;\n}\n\n.agent_pane__tab_close {\n    flex-shrink: 0;\n    background: none;\n    border: none;\n    padding: 0 4px;\n    font-size: 16px;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-text-muted);\n    opacity: 0.5;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__tab_close:hover {\n        opacity: 1;\n    }\n}\n\n\n.agent_pane__tab_new {\n    flex-shrink: 0;\n    background: none;\n    border: none;\n    padding: 0 10px;\n    font-size: 18px;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-text-muted);\n    opacity: 0.5;\n    transition: opacity 0.1s;\n    align-self: center;\n}\n\n@media (pointer: fine) {\n    .agent_pane__tab_new:hover:not(:disabled) {\n        opacity: 1;\n    }\n}\n\n.agent_pane__tab_new:disabled {\n    cursor: default;\n    opacity: 0.2;\n}\n\n/* Loading state */\n\n.agent_pane__loading {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.agent_pane__loading_spinner {\n    display: block;\n    width: 22px;\n    height: 22px;\n    border: 2px solid var(--color-border);\n    border-top-color: var(--color-accent);\n    border-radius: 50%;\n    animation: agent_pane_spin 0.7s linear infinite;\n}\n\n@keyframes agent_pane_spin {\n    to { transform: rotate(360deg); }\n}\n\n/* Empty state */\n\n.agent_pane__empty {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.agent_pane__empty_btn {\n    padding: 8px 22px;\n    background-color: var(--color-accent);\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    font-size: 13px;\n    cursor: pointer;\n    opacity: 0.9;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__empty_btn:hover:not(:disabled) {\n        opacity: 1;\n    }\n}\n\n.agent_pane__empty_btn:disabled {\n    opacity: 0.4;\n    cursor: default;\n}\n\n\n/* Last user prompt banner (shown when last user message is scrolled above viewport) */\n\n.agent_pane__prompt_banner {\n    position: absolute;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 7px 13px;\n    background-color: var(--color-bg);\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--color-text);\n    cursor: pointer;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    user-select: none;\n    transition: background-color 0.1s;\n}\n\n.agent_pane__prompt_banner--top {\n    top: 0;\n    border-bottom: 1px solid var(--color-border);\n}\n\n.agent_pane__prompt_banner--bottom {\n    bottom: 0;\n    border-top: 1px solid var(--color-border);\n}\n\n@media (pointer: fine) {\n    .agent_pane__prompt_banner:hover {\n        background-color: var(--color-bg-2);\n        filter: brightness(1.05);\n    }\n}\n\n/* Timeline */\n\n.agent_pane__timeline_wrap {\n    flex: 1;\n    min-height: 0;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.agent_pane__scroll_btn {\n    position: absolute;\n    bottom: 12px;\n    left: 50%;\n    transform: translateX(-50%);\n    padding: 3px 12px;\n    background-color: var(--color-bg);\n    border: 1px solid var(--color-border);\n    border-radius: 12px;\n    font-size: 13px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    opacity: 0.85;\n    transition: opacity 0.1s;\n    z-index: 1;\n    white-space: nowrap;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .agent_pane__scroll_btn:hover {\n        opacity: 1;\n    }\n}\n\n.agent_pane__timeline_wrap[data-banner-bottom] .agent_pane__scroll_btn {\n    bottom: calc(12px + 35px);\n}\n\n.agent_pane__timeline {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    scrollbar-width: thin;\n}\n\n.agent_pane__item {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding-top: 5px;\n    padding-left: 13px;\n    padding-right: 13px;\n}\n\n.agent_pane__item_label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    user-select: none;\n}\n\n.agent_pane__item_content {\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.agent_pane__item_pre {\n    margin: 0;\n    padding: 0;\n    font: inherit;\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow: hidden;\n}\n\n/* Thought */\n\n.agent_pane__item--thought .agent_pane__item_label {\n    color: var(--color-text-muted);\n}\n\n.agent_pane__item--thought .agent_pane__item_content {\n    color: var(--color-text-muted);\n    font-style: italic;\n}\n\n/* Action */\n\n.agent_pane__item--action .agent_pane__item_label {\n    color: var(--color-accent);\n}\n\n.agent_pane__item--action .agent_pane__item_content {\n    color: var(--color-text);\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    background-color: var(--color-bg);\n    border-radius: 3px;\n    padding: 6px 9px;\n}\n\n/* Result */\n\n.agent_pane__item--result .agent_pane__item_label {\n    color: var(--color-text-muted);\n}\n\n.agent_pane__item--result .agent_pane__item_content {\n    color: var(--color-text);\n}\n\n/* User */\n\n.agent_pane__item--user .agent_pane__item_label {\n    color: var(--color-accent);\n}\n\n.agent_pane__item--user .agent_pane__item_content {\n    color: var(--color-text);\n    font-weight: 500;\n}\n\n/* Pending */\n\n.agent_pane__item--pending {\n    opacity: 0.5;\n}\n\n/* Assistant */\n\n.agent_pane__item--assistant .agent_pane__item_label {\n    color: var(--color-text-muted);\n}\n\n.agent_pane__item--assistant .agent_pane__item_content {\n    color: var(--color-text);\n}\n\n/* Markdown rendering */\n\n.agent_pane__item_content--markdown {\n    line-height: 1.6;\n}\n\n.agent_pane__item_content--markdown > :first-child {\n    margin-top: 0;\n}\n\n.agent_pane__item_content--markdown > :last-child {\n    margin-bottom: 0;\n}\n\n.agent_pane__item_content--markdown p {\n    margin: 0 0 0.6em;\n}\n\n.agent_pane__item_content--markdown h1,\n.agent_pane__item_content--markdown h2,\n.agent_pane__item_content--markdown h3,\n.agent_pane__item_content--markdown h4,\n.agent_pane__item_content--markdown h5,\n.agent_pane__item_content--markdown h6 {\n    margin: 0.8em 0 0.3em;\n    font-weight: 600;\n    line-height: 1.3;\n}\n\n.agent_pane__item_content--markdown h1 { font-size: 1.2em; }\n.agent_pane__item_content--markdown h2 { font-size: 1.1em; }\n.agent_pane__item_content--markdown h3,\n.agent_pane__item_content--markdown h4,\n.agent_pane__item_content--markdown h5,\n.agent_pane__item_content--markdown h6 { font-size: 1em; }\n\n.agent_pane__item_content--markdown ul,\n.agent_pane__item_content--markdown ol {\n    margin: 0 0 0.6em;\n    padding-left: 1.4em;\n}\n\n.agent_pane__item_content--markdown li {\n    margin-bottom: 0.2em;\n}\n\n.agent_pane__item_content--markdown li > p {\n    margin-bottom: 0.2em;\n}\n\n.agent_pane__item_content--markdown code {\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 0.9em;\n    background-color: var(--color-bg);\n    padding: 1px 5px;\n    border-radius: 3px;\n}\n\n.agent_pane__item_content--markdown pre {\n    margin: 0.5em 0;\n    padding: 8px 11px;\n    background-color: var(--color-bg);\n    border-radius: 4px;\n    overflow-x: auto;\n}\n\n.agent_pane__item_content--markdown pre code {\n    background: none;\n    padding: 0;\n    font-size: 12px;\n    white-space: pre;\n}\n\n.agent_pane__item_content--markdown blockquote {\n    margin: 0.5em 0;\n    padding: 0 0 0 10px;\n    border-left: 3px solid var(--color-border);\n    color: var(--color-text-muted);\n}\n\n.agent_pane__item_content--markdown hr {\n    border: none;\n    border-top: 1px solid var(--color-border);\n    margin: 0.6em 0;\n}\n\n.agent_pane__item_content--markdown a {\n    color: var(--color-accent);\n    text-decoration: none;\n}\n\n.agent_pane__item_content--markdown a:hover {\n    text-decoration: underline;\n}\n\n.agent_pane__item_content--markdown strong {\n    font-weight: 600;\n}\n\n.agent_pane__item_content--markdown table {\n    border-collapse: collapse;\n    margin: 0.5em 0;\n    font-size: 12px;\n    width: 100%;\n}\n\n.agent_pane__item_content--markdown th,\n.agent_pane__item_content--markdown td {\n    border: 1px solid var(--color-border);\n    padding: 4px 8px;\n    text-align: left;\n}\n\n.agent_pane__item_content--markdown th {\n    background-color: var(--color-bg);\n    font-weight: 600;\n}\n\n/* Tool use widgets */\n\n.agent_pane__tool_widget {\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    gap: 7px;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    background-color: var(--color-bg);\n    border-radius: 3px;\n    padding: 5px 9px;\n    overflow: hidden;\n}\n\n.agent_pane__tool_widget--clickable {\n    cursor: pointer;\n    transition: background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__tool_widget--clickable:hover {\n        background-color: color-mix(in srgb, var(--color-accent) 8%, var(--color-bg));\n    }\n}\n\n.agent_pane__tool_widget_label {\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    flex-shrink: 0;\n    opacity: 0.65;\n}\n\n.agent_pane__tool_widget--read .agent_pane__tool_widget_label  { color: var(--color-accent); }\n.agent_pane__tool_widget--edit .agent_pane__tool_widget_label  { color: var(--color-warning, #e5a000); }\n.agent_pane__tool_widget--write .agent_pane__tool_widget_label { color: var(--color-warning, #e5a000); }\n.agent_pane__tool_widget--bash .agent_pane__tool_widget_label  { color: var(--color-success, #3fa542); }\n.agent_pane__tool_widget--grep .agent_pane__tool_widget_label  { color: var(--color-accent); }\n.agent_pane__tool_widget--glob .agent_pane__tool_widget_label  { color: var(--color-accent); }\n\n.agent_pane__tool_widget_path {\n    color: var(--color-text);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n}\n\n.agent_pane__tool_widget_range,\n.agent_pane__tool_widget_meta {\n    flex-shrink: 0;\n    color: var(--color-text-muted);\n    font-size: 11px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Bash widget */\n\n.agent_pane__tool_widget--bash {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 3px;\n}\n\n.agent_pane__tool_widget_desc {\n    font-family: inherit;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    font-style: italic;\n}\n\n.agent_pane__tool_widget_cmd {\n    margin: 0;\n    padding: 0;\n    font: inherit;\n    white-space: pre-wrap;\n    word-break: break-word;\n    color: var(--color-text);\n}\n\n.agent_pane__tool_widget_prompt {\n    color: var(--color-accent);\n    font-weight: 700;\n    user-select: none;\n}\n\n/* Permission */\n\n.agent_pane__item--permission .agent_pane__item_label {\n    color: var(--color-warning, #e5a000);\n}\n\n.agent_pane__perm_tool {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--color-text);\n    margin-bottom: 4px;\n}\n\n.agent_pane__perm_input {\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 12px;\n    background-color: var(--color-bg);\n    border-radius: 3px;\n    padding: 6px 9px;\n    margin: 4px 0;\n    white-space: pre-wrap;\n    word-break: break-all;\n    max-height: 132px;\n    overflow-y: auto;\n}\n\n.agent_pane__perm_actions {\n    display: flex;\n    gap: 7px;\n    margin-top: 7px;\n}\n\n.agent_pane__perm_btn {\n    padding: 3px 13px;\n    border: none;\n    border-radius: 3px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: opacity 0.1s;\n}\n\n.agent_pane__perm_btn--approve {\n    background-color: var(--color-accent);\n    color: #ffffff;\n}\n\n.agent_pane__perm_btn--approve_always {\n    background-color: var(--color-accent);\n    color: #ffffff;\n    opacity: 0.75;\n}\n\n.agent_pane__perm_btn--deny {\n    background-color: var(--color-bg);\n    color: var(--color-text);\n    border: 1px solid var(--color-border);\n}\n\n@media (pointer: fine) {\n    .agent_pane__perm_btn:hover {\n        opacity: 0.8;\n    }\n}\n\n.agent_pane__perm_responded {\n    font-size: 12px;\n    color: var(--color-text-muted);\n    margin-top: 4px;\n    font-style: italic;\n}\n\n/* Log (debug) */\n\n.agent_pane__item--log .agent_pane__item_label {\n    color: var(--color-text-muted);\n    opacity: 0.6;\n}\n\n.agent_pane__log {\n    display: flex;\n    gap: 9px;\n    align-items: baseline;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    opacity: 0.7;\n}\n\n.agent_pane__log_source {\n    font-weight: 600;\n    flex-shrink: 0;\n}\n\n.agent_pane__log_path {\n    word-break: break-all;\n}\n\n/* Collapsible tool usage blocks (action / result) */\n\n.agent_pane__item_content--collapsible {\n    cursor: pointer;\n}\n\n.agent_pane__item_content--collapsed {\n    position: relative;\n}\n\n.agent_pane__item_content--collapsed .agent_pane__item_pre {\n    max-height: 4.5em;\n    overflow: hidden;\n    mask-image: linear-gradient(to bottom, black 30%, transparent 100%);\n    -webkit-mask-image: linear-gradient(to bottom, black 30%, transparent 100%);\n}\n\n.agent_pane__item--action .agent_pane__item_pre,\n.agent_pane__item--result .agent_pane__item_pre {\n    min-height: 4.5em;\n}\n\n.agent_pane__expand_hint {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    text-align: center;\n    font-size: 11px;\n    letter-spacing: 0.25em;\n    color: var(--color-text-muted);\n    opacity: 0.55;\n    user-select: none;\n}\n\n/* Interrupted indicator */\n\n.agent_pane__interrupted {\n    margin-top: 7px;\n    font-size: 12px;\n    color: var(--color-warning, #e5a000);\n    font-style: italic;\n}\n\n/* Thinking / working indicator */\n\n.agent_pane__thinking {\n    font-size: 12px;\n    color: var(--color-text-muted);\n    opacity: 0.6;\n    font-style: italic;\n    padding: 2px 0 4px;\n    user-select: none;\n}\n\n/* Streaming indicator — three pulsing dots */\n\n.agent_pane__streaming_indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px 0;\n}\n\n.agent_pane__streaming_indicator span {\n    display: block;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background-color: var(--color-text-muted);\n    animation: agent_pane_dot_pulse 1.2s ease-in-out infinite;\n}\n\n.agent_pane__streaming_indicator span:nth-child(2) { animation-delay: 0.2s; }\n.agent_pane__streaming_indicator span:nth-child(3) { animation-delay: 0.4s; }\n\n@keyframes agent_pane_dot_pulse {\n    0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }\n    40%            { opacity: 1;   transform: scale(1); }\n}\n\n/* Input area */\n\n.agent_pane__input_area {\n    flex-shrink: 0;\n    padding: 11px 13px;\n    border-top: 1px solid var(--color-border);\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.agent_pane__input_row {\n    display: flex;\n    flex-direction: row;\n    gap: 9px;\n    align-items: flex-end;\n}\n\n/* Context bar */\n\n.agent_pane__context_chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    padding-bottom: 4px;\n}\n\n.agent_pane__context_bar {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 8px;\n    background-color: color-mix(in srgb, var(--color-accent) 12%, transparent);\n    border: 1px solid color-mix(in srgb, var(--color-accent) 35%, transparent);\n    border-radius: 4px;\n    font-size: 12px;\n    color: var(--color-accent);\n    user-select: none;\n    min-width: 0;\n}\n\n.agent_pane__context_icon {\n    flex-shrink: 0;\n    font-weight: 700;\n}\n\n.agent_pane__context_name {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: \"JetBrains Mono\", \"Fira Code\", Menlo, monospace;\n    font-size: 11px;\n}\n\n.agent_pane__context_dismiss {\n    flex-shrink: 0;\n    background: none;\n    border: none;\n    padding: 0 2px;\n    font-size: 15px;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-accent);\n    opacity: 0.6;\n    transition: opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__context_dismiss:hover {\n        opacity: 1;\n    }\n}\n\n/* Context toggle button */\n\n.agent_pane__context_btn {\n    flex-shrink: 0;\n    padding: 6px 9px;\n    height: 31px;\n    box-sizing: border-box;\n    background: none;\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-text-muted);\n    transition: color 0.1s, border-color 0.1s, background-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__context_btn:hover {\n        color: var(--color-text);\n        border-color: var(--color-text-muted);\n    }\n}\n\n.agent_pane__context_btn--active {\n    color: var(--color-accent);\n    border-color: var(--color-accent);\n    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);\n}\n\n/* Backend chooser (shown before first prompt) */\n\n.agent_pane__backend_chooser {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.agent_pane__backend_label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    user-select: none;\n    flex-shrink: 0;\n    margin-right: 2px;\n}\n\n.agent_pane__backend_btn {\n    padding: 2px 9px;\n    background: none;\n    border: 1px solid var(--color-border);\n    border-radius: 3px;\n    font-size: 11px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: color 0.1s, border-color 0.1s, background-color 0.1s;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .agent_pane__backend_btn:hover {\n        color: var(--color-text);\n        border-color: var(--color-text-muted);\n    }\n}\n\n.agent_pane__backend_btn--active {\n    color: var(--color-accent);\n    border-color: var(--color-accent);\n    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);\n}\n\n.agent_pane__input_area .text_input--textarea {\n    min-height: unset;\n    height: 31px;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    overflow: hidden;\n    line-height: normal;\n}\n\n@media (pointer: fine) and (pointer: fine) {\n    .agent_pane__input_area .text_input--textarea {\n        transition: height 0.15s ease;\n    }\n\n    .agent_pane__input_area .text_input--textarea:focus,\n    .agent_pane__input_area .text_input--textarea:not(:placeholder-shown) {\n        height: 90px;\n        overflow: auto;\n    }\n}\n\n.agent_pane__settings_btn {\n    flex-shrink: 0;\n    padding: 6px 10px;\n    height: 31px;\n    box-sizing: border-box;\n    background: none;\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    font-size: 15px;\n    line-height: 1;\n    cursor: pointer;\n    color: var(--color-text-muted);\n    transition: color 0.1s, border-color 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__settings_btn:hover {\n        color: var(--color-text);\n        border-color: var(--color-text-muted);\n    }\n}\n\n.agent_pane__send_btn {\n    flex-shrink: 0;\n    padding: 6px 18px;\n    height: 31px;\n    box-sizing: border-box;\n    background-color: var(--color-accent);\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background-color 0.1s, opacity 0.1s;\n}\n\n@media (pointer: fine) {\n    .agent_pane__send_btn:hover:not(:disabled) {\n        background-color: var(--color-accent-hover);\n    }\n}\n\n.agent_pane__send_btn:disabled {\n    opacity: 0.4;\n    cursor: default;\n}\n\n.agent_pane__send_btn--stop {\n    background-color: var(--color-danger, #d94f4f);\n}\n\n@media (pointer: fine) {\n    .agent_pane__send_btn--stop:hover {\n        background-color: var(--color-danger-hover, #c04040);\n    }\n}\n\n/* Per-session settings modal */\n\n.agent_pane__session_settings {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    min-width: 240px;\n    /* Room for long ids like openrouter/deepseek/deepseek-v4-pro in the model picker. */\n    width: min(420px, 80vw);\n}\n\n.agent_pane__session_settings_section {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.agent_pane__session_settings_label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--color-text-muted);\n    user-select: none;\n}\n\n.agent_pane__session_settings_options {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.agent_pane__session_settings_btn {\n    padding: 3px 10px;\n    background: none;\n    border: 1px solid var(--color-border);\n    border-radius: 3px;\n    font-size: 12px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    transition: color 0.1s, border-color 0.1s, background-color 0.1s;\n    user-select: none;\n}\n\n@media (pointer: fine) {\n    .agent_pane__session_settings_btn:hover {\n        color: var(--color-text);\n        border-color: var(--color-text-muted);\n    }\n}\n\n/* SelectInput defaults to flex: 1, which would stretch it vertically in this column. */\n.agent_pane__session_settings_select {\n    flex: none;\n    width: 100%;\n}\n\n.agent_pane__session_settings_status {\n    font-size: 12px;\n    color: var(--color-text-muted);\n}\n\n.agent_pane__session_settings_status--error {\n    color: var(--color-error);\n    white-space: pre-wrap;\n}\n\n.agent_pane__session_settings_btn--active {\n    color: var(--color-accent);\n    border-color: var(--color-accent);\n    background-color: color-mix(in srgb, var(--color-accent) 10%, transparent);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
